export const API_BASE_URL = import.meta.env.VITE_API_URL
export const ESCS_API_URL = import.meta.env.VITE_ESCS_API_URL
export const STORAGE_URL = import.meta.env.VITE_APP_STORAGE_URL

export const COOKIES_ALLOWED_KEY = '__escs_account_cookies_allowed'
export const COOKIES_JWT_KEY = '__escs_account_token'
export const COOKIES_REFRESH_KEY = '__escs_account_refresh'
export const COOKIES_REFRESH_EXP_KEY = '__escs_account_refresh_exp'
export const COOKIES_CREDENTIALS_KEY = '__escs_account_credentials'

export const AuthCredentialsTypeEnum = {
	ONE_TIME_PASSWORD: 'ONE_TIME_PASSWORD',
	EMAIL_AND_PASSWORD: 'EMAIL_AND_PASSWORD',
	GAME_BINDING: 'GAME_BINDING',
	SOCIAL_LOGIN: 'SOCIAL_LOGIN'
}

export const OAuthAuthorizedType = {
	AUTHORIZED: 'AUTHORIZED',
	UNAUTHORIZED: 'UNAUTHORIZED'
}

export const UserSessionModelStatusEnum = {
	ACTIVE: 'ACTIVE',
	EXPIRED: 'EXPIRED',
	TERMINATED: 'TERMINATED',
}

export const UserInfoStatusEnum = {
	ACTIVE: 'ACTIVE',
	PENDING: 'USER_STATUS_CONFIRMATION_PENDING'
}

export const ApplicationModelTypeEnum = {
	OAUTH_PROVIDER: 'OAUTH_PROVIDER',
	GAME_INTEGRATION: 'GAME_INTEGRATION'
}

export const ApplicationModelMetadataGameIntegrationApiRequestTypeEnum = {
	DEFAULT: 'DEFAULT',
	PRAGMA_GG: 'PRAGMA_GG'
}
